import { Component, Inject, Injector } from '@angular/core';
import { Base } from './model/base';
import { DomSanitizer } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { Service } from './service/service.service';

@Component({
  template: ''
})
export abstract class LauderComponent<E extends Base, S extends Service<E>> {
  protected service: S;
  protected router: Router;
  protected _sanitizer: DomSanitizer;

  constructor(protected injector: Injector) {
    this.router = injector.get(Router);
    this._sanitizer = injector.get(DomSanitizer);
  }

  goto(url: String) {
    this.router.navigate([url]);
  }

  sanitizer(url) {
    return this._sanitizer.bypassSecurityTrustStyle(`url(${url})`);
  }
}



// WEBPACK FOOTER //
// ./src/app/lauder-component.ts